import React from "react";
import { Image, Text, View } from "react-native";
import { SCREEN_WIDTH } from "../../common";
import Container from "../../components/Container";
import Header from "../../components/Header";
import dev from "./../../assets/images/develop.jpg";

function Development({ navigation }) {
  return (
    <Container>
      <Header backButton rightIcons={[]} navigation={navigation} />
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <Image
          source={dev}
          style={{ width: SCREEN_WIDTH * 0.7, height: SCREEN_WIDTH * 0.7 }}
        />
        <Text>This screen is under development</Text>
      </View>
    </Container>
  );
}

export default Development;
